import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const calendarService = {
  getCalendarEvents,
  getCalendarEventsOfGroup
}

function getCalendarEvents(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/calendar/get-list`, requestOptions)
}

function getCalendarEventsOfGroup(
  groupId,
  startDate,
  endDate,
  quantity,
  longitude = '',
  latitude = '',
  ipAddress = ''
) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      id_group: groupId,
      start_date: startDate,
      end_date: endDate,
      quantity,
      longitude: longitude,
      latitude: latitude,
      ip_address: ipAddress
    }
  }
  return doRequestAxios(`/v2/calendar/get-group-list`, requestOptions)
}
